import supportedRegions from './supportedRegions';

export default supportedRegions;
